import React, { useEffect } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Spin, Row, Col, Button, Input, Modal, Radio, Tabs } from 'antd'
import '../../css/users.scss'
import supportimg from '../../images/support.jpg'
import { getHelp, pages } from '../../tutorials'

const Support = (props) => {
  useEffect(() => {
    getHelp(pages.SUPPORT)
  }, [])
  return (
    <>
      <Col className='userContainer'>
        <Row className={'actionRow'} justify={'end'}>
          <Col style={{ marginRight: 'auto' }}>
            <Row className={'headerText'} gutter={20} align={'middle'}>
              <Col> MOVEAI SUPPORT </Col>
            </Row>
          </Col>
        </Row>
        <div>
          <Row gutter={40} align={'middle'} justify='center'>
            <img src={supportimg} style={{ width: 200, height: 'auto' }}></img>
          </Row>
          <Row gutter={40} align={'middle'} justify='center'>
            <Col id={'contactsupport'} style={{ fontSize: 18, marginTop: 20 }}>
              {' '}
              Please contact us via email:{' '}
              <b>
                <a href='mailto:support@moveaihealth.com'>
                  support@moveaihealth.com
                </a>
              </b>{' '}
            </Col>
          </Row>
        </div>
      </Col>
    </>
  )
}

export default Support
